import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { CellEditArgs, DataStateChangeEventArgs, EditSettingsModel, FilterSettingsModel, GridComponent, PageSettingsModel, SelectionSettingsModel } from '@syncfusion/ej2-angular-grids';
import { GlobalComponent } from 'src/app/global/global.component';
import { Observable, Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { ToastrService } from 'ngx-toastr';
import { DateService } from 'src/app/date.service';
import { IMyDpOptions } from 'mydatepicker';
import { DatePipe } from '@angular/common';
import { ConsultationServices } from '../consultation-services/consultation-services.service';
import { ClientHttpService } from '../client-parent/client-parent.service';
import { Router } from '@angular/router';
import { GetInbox, SaveInbox, Tickets } from './inbox.model';
import { InboxService } from './inbox.service';
import { CommonApiService } from 'src/app/commonapiservice';
import { TicketViewService } from '../ticket/ticket-view/ticket-view.service';
import { GetTicketsBO } from '../ticket/ticket.model';
import { LinkTickets } from '../engagement/engagement.modal';
import { EngagementService } from '../engagement/engagement.service';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { HttpErrorResponse } from '@angular/common/http';
@Component({
  selector: 'app-inbox',
  templateUrl: './inbox.component.html',
  styleUrls: ['./inbox.component.scss']
})
export class InboxComponent implements OnInit {
  public pageSizes: number[] = [10, 15, 20, 50, 100, 250];
  initialPage: PageSettingsModel;
  public myDatePickerOptions: IMyDpOptions = {
    dateFormat: 'mm/dd/yyyy',
    disableSince: { year: new Date().getFullYear(), month: new Date().getMonth() + 1, day: new Date().getDate() + 1 },
    showClearDateBtn: true,
    editableDateField: true
  };
  datetimeformat: object;
  public editSettings: EditSettingsModel;
  filterOptions: FilterSettingsModel;
  public InboxGrid: Observable<DataStateChangeEventArgs>;
  private onDestroy$: Subject<void> = new Subject<void>();
  @ViewChild('inboxgrid') public inboxgrid: GridComponent;
  @ViewChild('grid') public grid: GridComponent;
  public GridDataList: Observable<DataStateChangeEventArgs>;
  FilterStartDate: any = "";
  FilterEndDate: any = "";
  StartDate: any = "";
  EndDate: any = "";
  IBO: GetInbox = new GetInbox();
  InboxData: SaveInbox = new SaveInbox();
  SaveTickets: Tickets = new Tickets();
  arraycol: any = [];
  viewEngagement: boolean = false;
  tickets: any = [];
  TicketStatus: any = [];
  TicketPriority: any = [];
  TicketType: any = [];
  EmployeeDropdown: any = [];
  TotalHourse: any;
  ListSendBO = new GetTicketsBO();
  TicketsList: any;
  LinkTicket: LinkTickets = new LinkTickets();
  mappedId: string;
  status: any;
  ChannelNameList:{ Key: string, Value: string }[];
  QueueNameList:string[];
  CustomerTypeList : string[];
  DirectionList = ['INBOUND','OUTBOUND'];
  InboxDropdown: any = [];
  ticketsForm: FormGroup;
  Engagementlogid : string;
  openengagement :boolean=false;
  AllClientDropDownListwithStatus: any;
    @Input() clientTab: string;
    ValidationDate: string;

  constructor(public datepipe: DatePipe, public dateservice: DateService, public global: GlobalComponent, private toastrService: ToastrService
    , public CSService: ConsultationServices, public ClientService: ClientHttpService, public service: TicketViewService,
    public router: Router, public inboxservice: InboxService, public CommonAPI: CommonApiService ,public engagementservice: EngagementService,
    private formBuilder: FormBuilder,
  ) {
    this.InboxGrid = this.inboxservice;
      this.ticketsForm = this.formBuilder.group({
              id: ['00000000-0000-0000-0000-000000000000'],
              title: ['', Validators.required],
              description: ['', Validators.required],
              assignee: ['', Validators.required],
              tickettype: ['', Validators.required],
              status: ['', Validators.required],
              priority: [''],
        
            });

  }
  ngOnInit(): void {
    if (this.global.globalAgencyId == null ||
      this.global.globalAgencyId == undefined ||
      this.global.globalAgencyId == "" ||
      this.global.globalAgencyId == "00000000-0000-0000-0000-000000000000") {
      return;
    }
    this.datetimeformat = {
      type: "datetime",
      format: "MM/dd/yyyy h:mm:ss a",
    };
    this.filterOptions = { type: 'Menu' };
    this.initialPage = { currentPage: 1, totalRecordsCount: 0, pageCount: 10, pageSize: this.pageSizes[0], pageSizes: this.pageSizes };
    this.editSettings = { allowEditing: false, mode: 'Normal', allowEditOnDblClick: true }
    this.FilterStartDate = (new Date().getMonth() + 1) + '/' + new Date().getDate() + '/' + new Date().getFullYear();
    this.FilterEndDate = (new Date().getMonth() + 1) + '/' + new Date().getDate() + '/' + new Date().getFullYear();
    this.ChannelNameList = [{ Key: "CHAT", Value: "CHAT" },
                            { Key: "VOIP", Value: "VOIP" },
                            { Key: "PSTN", Value: "PSTN" },
                           ]
    this.getpermission();
    this.getEngagementsListFilter();
    this.getEmployeeDropdown();
    this.getTicketPriority();
    this.getTicketStatus();
    this.getTicketType();
    this.getTickets();
    this.getStatus();
    this.getFilterList();
    this.getInboxdd();
    this.getAllClient();

  }
  copyToClipboard(text: string) {
    navigator.clipboard.writeText(text).then(() => {
      this.toastrService.success("Copied to clipboard")
    }).catch(err => {
      console.error('Could not copy text: ', err);
    });
  }
      fp:any;
    getpermission() {
       let params = new URLSearchParams();
        params.append("pagecode", "INBOX");    
       let url = "api/FunctionPermission/getfunctionpermissionemployee?";
       this.CommonAPI.GetFunctionwithResponseTypeJson(params, url).pipe(takeUntil(this.onDestroy$)).subscribe((data: any) => {
         if (data != null) {
           this.fp = data;
         }
         else {
           this.fp = null;
         }
       },
         (err: HttpErrorResponse) => {
           this.fp = null;
         })
     }

  getEngagementsListFilter() {
    let SDate = this.FilterStartDate;
    let EDate = this.FilterEndDate;
    this.IBO.startDate = (SDate != null && SDate != undefined && SDate != "") ? this.global.getDateTimeStringWithOffset(SDate) : null
    this.IBO.endDate = (EDate != null && EDate != undefined && EDate != "") ? this.global.getDateTimeStringWithOffset(EDate) : null
     if(this.IBO.customerType !== 'CLIENT')
    {
      this.IBO.customerId = null;
    }
    if(this.clientTab == 'clienttab')
    {
      this.IBO.customerType = 'CLIENT';
      this.IBO.customerId = this.global.clientId
    }
    this.inboxservice.outputValues(this.IBO)
    let count = 0;
    this.InboxGrid.pipe(takeUntil(this.onDestroy$)).subscribe((data: any) => {
      this.InboxData = data.result;
      if (this.global.globalAgencyId != 0) {
        if (data != null && data.result?.length > 15) {
          this.inboxgrid.height = '500';
        }
        else {
          this.inboxgrid.height = 'auto';
        }
      }
    }
    )
  }
  formatDuration(duration: any): string {
    if (!duration || !duration.value) return "0 sec";

    const totalSeconds = Math.floor(duration.value.totalSeconds);
    const hours = Math.floor(totalSeconds / 3600);
    const minutes = Math.floor((totalSeconds % 3600) / 60);
    const seconds = totalSeconds % 60;

    return `${hours}hr ${minutes}mins ${seconds}sec`;
  }

  public dataStateChange(state): void {
    let type: String = (state.action.requestType).toString();
    this.IBO.currentpageno = this.inboxgrid.pagerModule.pagerObj.currentPage;
    this.IBO.pageitem = this.inboxgrid.pagerModule.pagerObj.pageSize;
    if (state.action.requestType != "filterchoicerequest") {
      if ((state.sorted || [])?.length) {
        this.IBO.orderColumn = state.sorted[0].name;
        this.IBO.orderType = state.sorted[0].direction === 'descending' ? 'DESC' : 'ASC';
      }
    }
    if (type == "filtering" && state.action.action != "clearFilter") {
      this.IBO.currentpageno = 1;
      this.IBO.pageitem = 10;
      if (this.IBO.type == "date") {
        this.IBO.value = (new Date(new Date(state.action.currentFilterObject.value).toDateString() + " " + "00:00:00" + " " + "GMT").toISOString()).replace("Z", "");
      }
      else {
        this.IBO.value = state.action.currentFilterObject.value;
      }
      this.IBO.field = state.action.currentFilterObject.field
      if (state.action.currentFilterObject.field == "isClientSign") {
        this.IBO.value = this.IBO.value == 'Yes' ? 'true' : 'false';
        this.IBO.type = "boolean";
      }
      if (state.action.currentFilterObject.field == "isEmployeeSign") {
        this.IBO.value = this.IBO.value == 'Yes' ? 'true' : 'false';
        this.IBO.type = "boolean";
      }
      if (state.action.currentFilterObject.field == "timesheetStatusLid") {
        this.IBO.field = "timesheetStatus"
        this.IBO.type = "string";
      }
      if (state.action.currentFilterObject.field == "totalHours") {
        this.IBO.value = this.IBO.value.toString();
      }
      // if (state.action.currentFilterObject.field == "dailyAuthorizedhours") {
      //   this.IBO.value = this.IBO.value.toString();
      // }
      this.IBO.operator = state.action.currentFilterObject.operator;
    }
    if (state.action.requestType == "filtering" && state.action.action == "clearFilter") {
      this.IBO.currentpageno = 1;
      this.IBO.pageitem = 10;
      this.IBO.operator = "contains"
      this.IBO.type = "string";
      this.IBO.value = "";
      this.IBO.field = "customerName";
      this.IBO.orderColumn = "startTime";
      this.IBO.orderType = 'desc';
    }
    if (state.action.requestType != "refresh") {
      this.getEngagementsListFilter();
    }
  }

  public onActionComplete(args) {
    if (args.requestType == "columnstate") {
      let hidearr = [];
      let showarr = [];
      this.inboxgrid.columns.forEach(element => {
        if (element.visible == false && element.headerText != "Actions" && element.headerText != "") {
          hidearr.push(element.headerText);
        }
        if (element.visible == true && element.headerText != "Actions" && element.headerText != "") {
          showarr.push(element.headerText);
        }
      })
      var count = 0;
      var count1 = 0;
      if (args.columns?.length > 0) {
        if (this.arraycol?.length > 0) {
          this.arraycol[0].EVV_Timesheet.ShowColumns.forEach(old => {
            showarr.forEach(element => {
              if (old == element) {
                count1 = count1 + 1;
              }
            });
          });
          this.arraycol[0].EVV_Timesheet.HideColumns.forEach(old => {
            hidearr.forEach(element => {
              if (old == element) {
                count = count + 1;
              }
            });
          });
          if (this.arraycol[0].EVV_Timesheet.ShowColumns?.length != count1 || this.arraycol[0].EVV_Timesheet.HideColumns?.length != count) {
            this.arraycol[0].EVV_Timesheet.ShowColumns = showarr;
            this.arraycol[0].EVV_Timesheet.HideColumns = hidearr;
            //this.SaveColumnwidth();
          }
        }

      }
    }
    if (args.requestType == "filterafteropen") {
      this.IBO.type = args.columnType;
    }
  }

  EditEngagement(event, data) {
    this.InboxData = data;
    // this.InboxData.duration = data.formattedDuration;
    this.InboxData.startTime = this.datepipe.transform(this.InboxData.startTime, "MM/dd/yyyy h:mm:ss a")
     this.InboxData.endTime = this.datepipe.transform(this.InboxData.endTime, "MM/dd/yyyy h:mm:ss a")
    this.SaveTickets.engagementLogsId = data.id;
    this.ListSendBO.id = data.id;
    this.Engagementlogid = data.id;
    this.openengagement = true;
    this.LinkTicket.engagementLogId = data.id;
    this.GetTicketsList();
  }
  getDeleteId(event, data) {
  }
  show() {
    this.inboxgrid.columnChooserModule.openColumnChooser();
  }
  newdates(event, type, name) {
    if (type == "inputchange") {
      if (name == 'StartDate') {
        let val = this.dateservice.inputFeildchange(event);
        if (val != undefined) {
          let val1 = this.dateservice.inputFeildchange(event);
          this.FilterStartDate = val1;
          this.clearEndTimeValidation();

        }
      }
      if (name == 'EndDate') {
        let val = this.dateservice.inputFeildchange(event);
        if (val != undefined) {
          let val1 = this.dateservice.inputFeildchange(event);
          this.FilterEndDate = val1;
          this.clearEndTimeValidation();
        }
      }
    }

    if (type == "datechanged") {
      if (name == 'StartDate') {
        let val = this.dateservice.Datechange(event);
        if (val != undefined) {
          let val1 = this.dateservice.Datechange(event);
          this.FilterStartDate = val1;
            var StartDate = new Date(this.FilterStartDate);
          let setDate = StartDate.setDate(StartDate.getDate() + 365);
          this.ValidationDate = this.datepipe.transform(setDate, "MM/dd/yyyy");
          this.clearEndTimeValidation();
        }
      }
      if (name == 'EndDate') {
        let val = this.dateservice.Datechange(event);
        if (val != undefined) {
          let val1 = this.dateservice.Datechange(event);
          this.FilterEndDate = val1;
          this.clearEndTimeValidation();
        }
      }
    }
  }
     clearEndTimeValidation() {
    if (this.FilterStartDate != null && this.FilterStartDate != undefined && this.FilterStartDate != '' &&
      this.FilterEndDate != null && this.FilterEndDate != undefined && this.FilterEndDate != '') {
      let EndDate = this.datepipe.transform(this.FilterEndDate, "MM/dd/yyyy");
      if (new Date(EndDate).getTime() > new Date(this.ValidationDate).getTime()) {
        this.toastrService.error("Date range should not be greater than 1 year");
        setTimeout(() => {
          this.toastrService.clear();
        }, 3000);
        this.FilterEndDate = null;
      }
      if (this.FilterEndDate != null && this.FilterEndDate != undefined && this.FilterEndDate != '') {
        if (new Date(this.FilterStartDate).getTime() > new Date(this.FilterEndDate).getTime()) {
          this.FilterEndDate = null;
          this.toastrService.error("end time should greater than start time");
          setTimeout(() => {
            this.toastrService.clear();
          }, 3000);
          return;
        }
      }
    }

  }
  clearengagement() {
    this.IBO.direction ='';
    this.IBO.channelName = '';
    this.IBO.queueName = '';
    this.IBO.statusLid =null;
    this.IBO.assignedEmployeeId =null;
    this.IBO.engagementIds = [];
    this.IBO.customerType = null;
    this.FilterStartDate = (new Date().getMonth() + 1) + '/' + new Date().getDate() + '/' + new Date().getFullYear();
    this.FilterEndDate = (new Date().getMonth() + 1) + '/' + new Date().getDate() + '/' + new Date().getFullYear();
    
    this.openengagement = false;
    this.getEngagementsListFilter();
  }
  cancel() {
    this.viewEngagement = false;
  }
  getTicketStatus() {
    let url = "api/LOV/getLovDropDown?";
    let params = new URLSearchParams();
    params.append("ListCode", 'TICKETSTATUS');
    this.CommonAPI.getDropDownList("TICKETSTATUS", params, url, "LovDropDown").then(
      (data: any) => {
        this.TicketStatus = data;
      },
      (err) => { }
    );
  }
  getTicketPriority() {
    let url = "api/LOV/getLovDropDown?";
    let params = new URLSearchParams();
    params.append("ListCode", 'TICKETPRIORITY');
    this.CommonAPI.getDropDownList("TICKETPRIORITY", params, url, "LovDropDown").then(
      (data: any) => {
        this.TicketPriority = data;
      },
      (err) => { }
    );
  }
  getTicketType() {
    let url = "api/LOV/getLovDropDown?";
    let params = new URLSearchParams();
    params.append("ListCode", 'TICKETTYPE');
    this.CommonAPI.getDropDownList("TICKETTYPE", params, url, "LovDropDown").then(
      (data: any) => {
        this.TicketType = data;
      },
      (err) => { }
    );
  }
  getStatus() {
    let url = "api/LOV/getLovDropDown?";
    let params = new URLSearchParams();
    params.append("ListCode", 'INBOXSTATUS');
    this.CommonAPI.getDropDownList("INBOXSTATUS", params, url, "LovDropDown").then(
      (data: any) => {
        this.status = data;
      },
      (err) => { }
    );
  }

  getEmployeeDropdown() {
    let myParams = new URLSearchParams();
    // myParams.append("LocationId", this.locationId.toString());
    let url = "api/Employee/employeeDropDown?";
    this.CommonAPI
      .GetFunctionwithResponseTypeJson(myParams, url)
      .pipe(takeUntil(this.onDestroy$))
      .subscribe((data: any) => {
        data.forEach((element) => {
          element.Value = element.Value;
          element.Key = element.Key.toString();
        });
        this.EmployeeDropdown = data;
      });
  }
  getTickets() {
    let myParams = new URLSearchParams();
    let url = "api/Ticket/TicketsDropdown?";
    this.CommonAPI
      .GetFunctionwithResponseTypeJson(myParams, url)
      .pipe(takeUntil(this.onDestroy$))
      .subscribe((data: any) => {
        data.forEach((element) => {
          element.Value = element.Value;
          element.Key = element.Key.toString();
        });
        this.tickets = data;
      });
  }
  createTickets(event) {
    let url;
    url = "api/Ticket/SaveTicket";
    this.CommonAPI.saveorUpdateFunctionwithResponseTypeJson(this.SaveTickets, url).pipe(takeUntil(this.onDestroy$)).subscribe((data: any) => {
      if(event =='create')
        this.toastrService.success("Ticket Added Successfully");
      else
         this.toastrService.success("Ticket Updated Successfully")
      this.GetTicketsList();
      this.getTickets();
      document.getElementById('openticket').click();
    },
      (err: any) => {
        this.toastrService.error(err)
        setTimeout(() => {
          this.toastrService.clear()
        }, 4000);
      })

  }

  GetTicketsList() {
    let myParams = new URLSearchParams();
    myParams.append("Id", this.ListSendBO.id)
    let url;
    url = "api/EngagementLogsTicketsMapping/GetMappedTicketsForEngagementLog?";
    this.CommonAPI.saveorUpdateFunctionwithParams(myParams, url).pipe(takeUntil(this.onDestroy$)).subscribe((data) => {
      this.TicketsList = data;
    },
      (err: any) => {
        this.toastrService.error(err);
      })
  }
  selectedItem(data) {
    this.mappedId = data.mappedId;

  }
  DeleteTickets() {
    let myParams = new URLSearchParams();
    myParams.append("Id", this.mappedId)
    let url;
    url = "api/EngagementLogsTicketsMapping/DeleteEngagementLogTicketMapping?";
    this.CommonAPI.saveorUpdateFunctionwithParams(myParams, url).pipe(takeUntil(this.onDestroy$)).subscribe((data) => {
      this.GetTicketsList();
      document.getElementById('OpenDeletetickets').click();
    },
      (err: any) => {
        this.toastrService.error(err);
      })
  }
  LinkTicketsList() {
    let url;
    url = "api/EngagementLogsTicketsMapping/MapTicketstoEngagementLog";
    this.CommonAPI.saveorUpdateFunctionwithResponseTypeJson(this.LinkTicket, url).pipe(takeUntil(this.onDestroy$)).subscribe((data: any) => {
      this.toastrService.success("Ticket Linked Successfully");
      this.GetTicketsList();
      document.getElementById('openlinkticket').click();
      this.LinkTicket.ticketIds = [];
    },
      (err: any) => {
        this.toastrService.error(err);
      })

  }
  saveInbox() {
    let url;
    url = "api/EngagementLogs/SaveInbox"
    this.CommonAPI.saveorUpdateFunctionwithResponseTypeJson(this.InboxData, url).pipe(takeUntil(this.onDestroy$)).subscribe((data: any) => {
      this.toastrService.success("Inbox Saved Successfully");
    },
      (err: any) => {
        this.toastrService.error(err);
      }
    )
  }
  getFilterList(){
    this.engagementservice.getFilterList().pipe().subscribe((data)=>{
      this.QueueNameList = data.queueName;
      this.CustomerTypeList = data.customerTypeList;
 
    })

  }
  getInboxdd() {
    let myParams = new URLSearchParams();
    let url = "api/EngagementLogs/InboxDropdown?";
    this.CommonAPI
      .GetFunctionwithResponseTypeJson(myParams, url)
      .pipe(takeUntil(this.onDestroy$))
      .subscribe((data: any) => {
        data.forEach((element) => {
          element.Value = element.Value;
          element.Key = element.Key.toString();
        });
        this.InboxDropdown = data;
      });
  }

    EditTicket(data)
  {
    this.SaveTickets = data;
  }
  createTicket(){
    this.SaveTickets = new Tickets();
    this.SaveTickets.engagementLogsId = this.Engagementlogid; 
    document.getElementById('openticket').click();
  }
       getAllClient() {
    let param = new URLSearchParams();

    let locId;
    if (this.global.globalLocationId != null && this.global.globalLocationId != ''
      && this.global.globalLocationId != undefined) {
      locId = parseInt(this.global.globalLocationId);
    }
    else {
      locId = "00000000-0000-0000-0000-000000000000";
    }
    param.append("LocationId", locId);
    let url = "api/Client/GetAllClientsDropDownbyAgency?"
    this.CommonAPI.GetFunctionwithResponseTypeJson(param, url).pipe(takeUntil(this.onDestroy$)).subscribe((data: any[]) => {
     this.AllClientDropDownListwithStatus = JSON.parse(JSON.stringify(data));
      this.AllClientDropDownListwithStatus.forEach(record => {
          record.Key = record.id.toString();
          record.Value = record.names + " (" + record.status + ")";
          
          if (record.medicaid) {
            record.Value += " (" + record.medicaid + ")";
          }
        });                  
    })
  }

}